enum COMPARATOR_TYPE {
  CAR = 'car',
  ENERGY = 'energy',
  HOME = 'home',
}

enum PRODUCT_TYPE {
  ELECTRICITY = 'electricity',
  GAS = 'gas',
}

export { COMPARATOR_TYPE, PRODUCT_TYPE };
